var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFans({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0323 15.769C10.3176 15.769 6.34082 16.6283 6.34082 19.8995C6.34082 23.1708 10.3449 24 15.0323 24C19.7197 24 23.7238 23.1557 23.7238 19.8694C23.7238 16.583 19.7197 15.769 15.0323 15.769Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0326 12.6477C16.5561 12.6477 18.0174 11.9811 19.096 10.7942C20.1746 9.60723 20.7823 7.99682 20.786 6.31622C20.7805 5.06422 20.4395 3.84198 19.8058 2.80326C19.1722 1.76454 18.2741 0.95575 17.2248 0.478705C16.1754 0.00166032 15.0216 -0.122286 13.9085 0.122349C12.7954 0.366983 11.7728 0.969264 10.9693 1.85353C10.1657 2.73779 9.61728 3.86444 9.39288 5.09174C9.16849 6.31904 9.27811 7.59222 9.70809 8.75091C10.1381 9.9096 10.8691 10.9021 11.8093 11.6035C12.7494 12.305 13.8566 12.6841 14.9915 12.693",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4546 7.7491C27.6461 6.95278 27.6701 6.1188 27.525 5.31064C27.38 4.50249 27.0696 3.74148 26.6175 3.08574C26.1654 2.42999 25.5836 1.89678 24.9163 1.52671C24.2491 1.15664 23.514 0.959456 22.7672 0.950264C22.4417 0.956275 22.1172 0.991578 21.7969 1.0558L21.6876 1.13116C21.6744 1.15637 21.6675 1.18495 21.6675 1.21406C21.6675 1.24317 21.6744 1.27184 21.6876 1.29705C22.6408 2.78222 23.1518 4.55759 23.1498 6.37732C23.1514 8.12022 22.6751 9.82288 21.7833 11.2616C21.7626 11.2828 21.746 11.3084 21.7347 11.337C21.7234 11.3655 21.7176 11.3963 21.7176 11.4274C21.7176 11.4585 21.7234 11.4893 21.7347 11.5179C21.746 11.5464 21.7626 11.572 21.7833 11.5932C21.8098 11.6036 21.8387 11.6036 21.8652 11.5932C22.0837 11.608 22.3027 11.608 22.5212 11.5932C23.6146 11.6384 24.6892 11.2699 25.5667 10.5488C26.4441 9.82765 27.0717 8.79718 27.3453 7.62848",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8053 16.1911C29.4946 15.6344 29.0689 15.1667 28.563 14.8261C28.0571 14.4855 27.4853 14.2817 26.8944 14.2313C25.4367 13.9134 23.9525 13.7669 22.4667 13.7942C22.4607 13.8057 22.4575 13.8187 22.4575 13.8319C22.4575 13.8452 22.4607 13.8581 22.4667 13.8696C23.6144 14.4244 24.5793 15.3561 25.2297 16.5376C25.8802 17.7191 26.1847 19.0931 26.1018 20.4724C26.096 20.5072 26.0968 20.543 26.1041 20.5775C26.1115 20.612 26.1252 20.6444 26.1444 20.6727C26.1637 20.701 26.188 20.7247 26.216 20.7421C26.2439 20.7595 26.2749 20.7704 26.3068 20.7739C27.0858 20.6533 29.122 20.1709 29.7507 18.6634C29.9151 18.2685 30.0002 17.8392 30.0002 17.4047C30.0002 16.9702 29.9151 16.5407 29.7507 16.1459",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.194706 16.1911C0.505444 15.6344 0.931132 15.1667 1.43702 14.8261C1.9429 14.4855 2.51465 14.2817 3.10556 14.2313C4.56332 13.9134 6.04752 13.7669 7.53331 13.7942C7.5393 13.8057 7.54248 13.8187 7.54248 13.8319C7.54248 13.8452 7.5393 13.8581 7.53331 13.8696C6.38555 14.4244 5.42074 15.3561 4.77026 16.5376C4.11978 17.7191 3.8153 19.0931 3.8982 20.4724C3.90403 20.5072 3.9032 20.543 3.89587 20.5775C3.88854 20.612 3.87484 20.6444 3.85558 20.6727C3.83632 20.701 3.81196 20.7247 3.78402 20.7421C3.75607 20.7595 3.72512 20.7704 3.69318 20.7739C2.91422 20.6533 0.877973 20.1709 0.24934 18.6634C0.0848823 18.2685 -0.000223637 17.8392 -0.000223637 17.4047C-0.000223637 16.9702 0.0848823 16.5407 0.24934 16.1459",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19944 1.0558C7.88385 0.990821 7.56381 0.955508 7.24281 0.950264C6.60044 0.95221 5.96477 1.09447 5.3725 1.36882C4.78024 1.64317 4.24316 2.04421 3.79213 2.54876C3.34109 3.05331 2.98507 3.65136 2.74466 4.30846C2.50426 4.96557 2.3842 5.66876 2.39142 6.37732C2.39029 6.84062 2.44543 7.30196 2.55541 7.7491C2.82897 8.91781 3.45651 9.94819 4.33396 10.6693C5.21141 11.3905 6.28608 11.759 7.37952 11.7138C7.59797 11.7287 7.81701 11.7287 8.03546 11.7138C8.06385 11.7103 8.09128 11.7003 8.11595 11.6844C8.14062 11.6685 8.16194 11.6471 8.17867 11.6215C8.1954 11.596 8.20711 11.5668 8.21304 11.536C8.21896 11.5051 8.21901 11.4733 8.21312 11.4425C8.21905 11.4076 8.21905 11.3718 8.21312 11.337C7.3184 9.85755 6.85004 8.1143 6.86955 6.33601C6.88906 4.55772 7.39555 2.8275 8.32247 1.37241C8.33567 1.3472 8.34257 1.31862 8.34257 1.28951C8.34257 1.2604 8.33567 1.23181 8.32247 1.20661C8.28854 1.16947 8.24595 1.14332 8.19944 1.13116",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.0323,
    y1: 24,
    x2: 15.0323,
    y2: 15.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.0326,
    y1: 12.693,
    x2: 15.0326,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 24.643,
    y1: 11.6043,
    x2: 24.643,
    y2: 0.950264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 26.2289,
    y1: 20.7739,
    x2: 26.2289,
    y2: 13.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 3.77113,
    y1: 20.7739,
    x2: 3.77113,
    y2: 13.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C9FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 5.36685,
    y1: 11.725,
    x2: 5.36685,
    y2: 0.950264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53AFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFans);
export default __webpack_public_path__ + "static/media/fans.a799947dbac53ba045cf0ddafd59a868.svg";
export { ForwardRef as ReactComponent };